import React from 'react'

function Loader() {
  return (
    <div className="loader">
      <div className="loader__spinner"></div>
    </div>
  )
}

export default Loader
